module.exports = __webpack_public_path__ + "static/media/extensive-database.336d7b2b.png";